import styled from 'styled-components';

export const Container = styled.span.attrs(({ icon }) => ({
  className: `cl-${icon}`,
}))`
  font-size: inherit;
  color: inherit;
`;
